
/**
 * Triggered by saga when a user is logged in
 */
export const LOGGED_IN = 'LOGGED_IN';

/**
 * Triggered by a saga when a user is logged out
 */
export const ANONYMOUS = 'ANONYMOUS';

/**
 * Triggered by a saga when a user is trying to log in
 */
export const AWAITING_AUTH_RESPONSE = 'AWAITING_AUTH_RESPONSE';

/**
 * Triggered by the app to store the authentication adapter in state
 */
export const SET_AUTH_ADAPTER = 'SET_AUTH_ADAPTER';

/**
 * Triggered by the app to store the db adapter in state
 */
export const SET_DB_ADAPTER = 'SET_DB_ADAPTER';

/**
 * Triggered by the app to initiate a logout
 */
export const LOGOUT = 'LOGOUT';

/**
 * Triggered by the app to initiate a login
 */
export const LOGIN = 'LOGIN';

/**
 * Triggered when the title of a draft changes
 */
export const DRAFT_TITLE_CHANGE = 'DRAFT_TITLE_CHANGE';

/**
 * Triggered when the content of a draft changes
 */
export const DRAFT_CONTENT_CHANGE = 'DRAFT_CONTENT_CHANGE';

/**
 * Triggered when the user clicks create on /pages/new
 */
export const CREATE_PAGE = 'CREATE_PAGE';

/**
 * Triggered when the user clicks delete on pages/:pageId/edit
 */
export const DELETE_PAGE = 'DELETE_PAGE';

/**
 *  Triggered when the user clicks save on /pages/:pageId/edit
 */
export const EDIT_PAGE = 'EDIT_PAGE';

/**
 * Triggered when a page needs to be fetched
 */
export const FETCH_PAGE = 'FETCH_PAGE';

/**
 * Triggered when a page needs to be fetched and copied into draft
 */
export const FETCH_DRAFT = 'FETCH_DRAFT';

/**
 * Triggered when the page index needs to be fetched
 */
export const FETCH_PAGE_INDEX = 'FETCH_PAGE_INDEX';

/**
 * Triggered when we receive a page from firebase
 *
 * @param key - the unique id of the record
 * @param value - the value object
 */
export const RECEIVE_PAGE = 'RECEIVE_PAGE';

/**
 * Triggered when a child is added to the page index
 *
 * @param key - the page id
 * @param value - the value object
 */
export const RECEIVE_PAGE_INDEX = 'RECEIVE_PAGE_INDEX';

/**
 * Triggered when we receive a version from firebase
 *
 * @param key - the version id
 * @param value - the value object
 */
export const RECEIVE_VERSION = 'RECEIVE_VERSION';

/**
 * Triggered when we receive content from firebase
 *
 * @param key - the version id of the content
 * @param value - the value object
 */
export const RECEIVE_CONTENT = 'RECEIVE_CONTENT';

/**
 * Triggered when a child is removed from the page index
 *
 * @param key
 */
export const REMOVE_PAGE_INDEX = 'REMOVE_PAGE_INDEX';

/**
 * Triggered when we receive a profile from firebase
 *
 * @param profile - the user profile
 */
export const RECEIVE_PROFILE = 'RECEIVE_PROFILE';

/**
 * Triggered when we want to store a redux-saga channel in the store
 */
export const STORE_CHANNEL = 'STORE_CHANNEL';



/** WEBPACK FOOTER **
 ** ./src/constants.js
 **/